import metaLogo from "@assets/images/meta-logo.svg";
import gtmLogo from "@assets/images/gtm-logo.svg";

const logos = {
  meta_pixel: metaLogo,
  gtm: gtmLogo,
};

export default logos;